import { useBreakpoint } from 'src/hooks';
import { ModelPricingTable } from './components/ModelPricingTable';
import { ModelPricingMobileTable } from './components/ModelPricingMobileTable';

export const ModelPricing = () => {
  const { isMobileOrTablet } = useBreakpoint();

  return (
    <>
      {isMobileOrTablet ? <ModelPricingMobileTable /> : <ModelPricingTable />}
    </>
  );
};
